/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useEffect } from "react";
import { useVideoPlayer2 } from "../hooks/use-video-player-2-setup-start";

type KeyboardShortcutsProps = {
  show: boolean;
  onClose: () => void;
};

export function KeyboardShortcuts({ show, onClose }: KeyboardShortcutsProps) {
  const player = useVideoPlayer2();

  useEffect(() => {
    if (!show) return;

    const handleKeyDown = (e: KeyboardEvent) => {
      // Hide shortcuts on Escape
      if (e.key === "Escape") {
        onClose();
        e.preventDefault();
      }
    };

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [show, onClose]);

  if (!show) return null;

  const shortcuts = [
    {
      key: "Space",
      description: player.trans("play") + " / " + player.trans("pause"),
    },
    {
      key: "← →",
      description:
        player.trans("rewind") + " / " + player.trans("forward") + " 10s",
    },
    { key: "↑ ↓", description: player.trans("volumeUpDown") },
    { key: "F", description: player.trans("fullscreen") },
    {
      key: "M",
      description: player.trans("mute") + " / " + player.trans("unmute"),
    },
    { key: "Double Tap", description: player.trans("doubleTapSeek") },
    ...(player.props.enableDoubleSpeedTap === true
      ? [
          { key: "Shift + →", description: player.trans("holdFor2xSpeed") },
          { key: "Right Half", description: player.trans("clickFor2xSpeed") },
        ]
      : []),
  ];

  return (
    <div className="video-player-2-keyboard-shortcuts" onClick={onClose}>
      <div
        className="video-player-2-keyboard-shortcuts__content"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="video-player-2-keyboard-shortcuts__header">
          <h3>{player.trans("keyboardShortcuts")}</h3>
          <button
            className="video-player-2-keyboard-shortcuts__close"
            onClick={onClose}
            aria-label="Close shortcuts"
          >
            ×
          </button>
        </div>
        <div className="video-player-2-keyboard-shortcuts__list">
          {shortcuts.map((shortcut, index) => (
            <div
              key={index}
              className="video-player-2-keyboard-shortcuts__item"
            >
              <span className="video-player-2-keyboard-shortcuts__key">
                {shortcut.key}
              </span>
              <span className="video-player-2-keyboard-shortcuts__description">
                {shortcut.description}
              </span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
